var map = {
	"./character/poster1-character.png": 5617,
	"./character/poster2-character.png": 6690,
	"./character/poster3-character.png": 2207,
	"./music/poster1-music.png": 9961,
	"./music/poster2-music.png": 2706,
	"./music/poster3-music.png": 4415,
	"./prompt/poster1-prompt.png": 5229,
	"./prompt/poster2-prompt.png": 3668,
	"./prompt/poster3-prompt.png": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1859;